import { styled } from '@mui/material';
import { CoreBox } from '@youscience/core';

export const StyledCardHeaderExpand = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '1rem',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledCardHeaderExpandButton = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isExtended',
})<{ isExtended?: boolean }>(({ isExtended, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '2rem',
  height: '2rem',
  borderRadius: '2.5rem',

  '&:hover': {
    cursor: 'pointer',
    background: theme.palette.grey[100],
  },

  '& > svg:first-of-type': {
    fill: theme.palette.common.black,
    transform: isExtended ? 'rotate(180deg)' : 'rotate(0deg)',
  },

  [theme.breakpoints.down('md')]: {
    flexDirection: 'row',
  },
}));
